<footer class="app-footer">
  <div class="footer-content">
    <div class="footer-section links">
      <h3>Quick Links</h3>
      <ul>
        <li><a (click)="navigateTo('/home')">Home</a></li>
        <li><a (click)="navigateTo('/my-knowledge')">My Knowledge</a></li>
        <li><a (click)="navigateTo('/my-health/period-tracker')">Period Tracker</a></li>
        <li><a (click)="navigateTo('/find-a-service')">Find A Service</a></li>
        <li><a (click)="navigateTo('/about')">About</a></li>
      </ul>
    </div>
    <div class="footer-section links">
      <h3>Legal</h3>
      <ul>
        <li><a (click)="navigateTo('/privacy-policy')">Privacy Policy</a></li>
        <li><a (click)="navigateTo('/terms-of-use')">Terms of Use</a></li>
      </ul>
    </div>
    <div class="footer-section social">
      <h3>Follow Us</h3>
      <div class="social-icons">
        <a href="https://x.com/UNFPA_SYP" target="_blank" aria-label="Twitter"><img src="assets/x.png" alt="X"></a>
	  <a href="https://www.facebook.com/UNFPASafeguardYoungPeople/" target="_blank" aria-label="Facebook"><img src="assets/facebook.png" alt="Facebook"></a>
        <a href="https://www.instagram.com/unfpa_syp/" target="_blank" aria-label="Instagram"><img src="assets/instagram.png" alt="Instagram"></a>
        <a href="https://www.youtube.com/@unfpasafeguardyoungpeoplep7420/videos" target="_blank" aria-label="Youtube"><img src="assets/youtube.png" alt="Youtube"></a>
      </div>
    </div>
    <div class="footer-section partner-logos">
      <div class="logo-grid">
        <div class="logo-row">
          <img src="assets/UNFPA-Logo.png" alt="UNFPA Logo">
          <div class="vertical-line"></div>
          <img src="assets/SYP Logo.png" alt="SYP Logo">
        </div>
        <h3 class="supported-by">Supported by</h3>
        <div class="logo-row-bottom">
          <img src="assets/BZ_Logo_online_ex_pos_en.png" alt="EKN Logo">
          <img src="assets/Switzerland_development.png" alt="SDC Logo">
        </div>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <p>&copy; {{ currentYear }} Tune Me. All rights reserved.</p>
  </div>
</footer>